// extracted by mini-css-extract-plugin
export var actionPlaceholder = "_ao-3";
export var contentContainer = "_ao-0";
export var editorContainer = "_ao-1";
export var quillInputForm = "_ao-2";
export var zoneDivider = "_ao-4";